#import "../fragments/AutomationFields.graphql"

query Automation($id: ID!) {
  automation(id: $id) {
    ...AutomationFields
  }
}
